import React from 'react'
import { node, string, shape, func } from 'prop-types'
import { Card, Divider, BillboardButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import FamilyGroupCardContent from './FamilyGroupCardContent'

export default function ButtonCard({ children, buttonKey, buttonFallback, buttonProps, ...cardContentProps }) {
  const { t } = useTranslation()

  return (
    <Card>
      <FamilyGroupCardContent {...cardContentProps} />
      <Divider marginY="xxs" />
      <BillboardButton emphasis="low" color="purple" {...buttonProps}>
        <b>{t(buttonKey, buttonFallback)}</b>
      </BillboardButton>
      {children}
    </Card>
  )
}

ButtonCard.propTypes = {
  children: node,
  buttonKey: string.isRequired,
  buttonFallback: string.isRequired,
  buttonProps: shape({
    to: string,
    onClick: func,
  }),
}
